import { createSlice } from '@reduxjs/toolkit';
import { IWellWaterSystemWCoordinates } from '../../../types';
import { createWellWaterSystemCoordinatesAsync, createWellWaterSystemCoordinatesAsyncBuilder } from './asyncRequest';

interface IWellWaterSystemCoordinatesData {
  items : IWellWaterSystemWCoordinates[]
}

export interface WellWaterSystemCoordinatesInitialState {
  data: IWellWaterSystemCoordinatesData
  loading: boolean;
  error: string;
  success: boolean;
}

const initialState: WellWaterSystemCoordinatesInitialState = {
  data: {} as IWellWaterSystemCoordinatesData,
  loading: false,
  error: '',
  success: false,
};

export const WellWaterSystemCoordinatesSlice = createSlice({
    name: 'wellWaterSystemCoordinatesSlice',
    initialState,
    reducers: {
      resetWellWaterSystemCoordinates:(state)=>{
        state.data = initialState.data
      }
    },
    extraReducers: (builder) => {
        createWellWaterSystemCoordinatesAsyncBuilder(builder)
      },
    });
    
  export const WellWaterSystemCoordinatesActions = {
    ...WellWaterSystemCoordinatesSlice.actions,
    createWellWaterSystemCoordinatesAsync,
  };
  
export const WellWaterSystemCoordinatesReducer = WellWaterSystemCoordinatesSlice.reducer;